module.exports = __webpack_public_path__ + "img/sigin_get_2.8467e037.png";